import { Service } from '../types';

export const services: Service[] = [
  {
    id: 'web-development',
    title: 'Website Design & Development',
    description: 'Building responsive, modern websites with seamless performance and ongoing support.',
    icon: 'Globe',
    features: ['Responsive Design', 'SEO Optimized', 'Fast Performance', 'Ongoing Support']
  },
  {
    id: 'app-development',
    title: 'Application Development',
    description: 'Complete app lifecycle services from design to deployment and maintenance.',
    icon: 'Smartphone',
    features: ['Web & Mobile Apps', 'Custom Solutions', 'Cloud Deployment', 'Maintenance']
  },
  {
    id: 'business-strategy',
    title: 'Business Analysis & Strategy',
    description: 'Aligning digital presence with business goals through actionable insights.',
    icon: 'BarChart3',
    features: ['Strategic Planning', 'Digital Transformation', 'Process Optimization', 'Growth Strategy']
  },
  {
    id: 'data-analysis',
    title: 'Data Analysis & Visualization',
    description: 'Transforming raw data into clear, interactive visuals for better decision-making.',
    icon: 'PieChart',
    features: ['Interactive Dashboards', 'Business Intelligence', 'Data Mining', 'Predictive Analytics']
  },
  {
    id: 'seo-marketing',
    title: 'SEO & Digital Marketing',
    description: 'Boosting visibility and audience reach through optimized SEO strategies.',
    icon: 'Search',
    features: ['SEO Optimization', 'Google Analytics', 'Content Strategy', 'Performance Tracking']
  },
  {
    id: 'design-services',
    title: 'UI/UX & Graphic Design',
    description: 'Creating user-first designs and professional branding assets.',
    icon: 'Palette',
    features: ['UI/UX Design', 'Brand Identity', 'Pitch Decks', 'Creative Assets']
  }
];